import styled,{ keyframes } from 'styled-components'
import logofarmasis from "../../imgs/farmasis.png"
import compartir from "../../imgs/compartir.png"
import check from "../../imgs/check.png"
import {baseURLCompartido} from "../../services/authentication.js"
import {useDispatch,useSelector} from 'react-redux';
import {urlVideo,open,setId,setIdCopy} from "../../redux/actions.js"
import AddIcon from '@mui/icons-material/Add';
import './cardProm.css'



const marqueeTop = keyframes`
  0% {
    transform: translateX(119%);
  }
  100% {
    transform: translateX(-110%);
  }
`;





let Container=styled.div`
	position:relative;	
	display:flex;
	flex-direction:column;
	transition-duration: 500ms;
	&:hover{
		scale:1.1;
	};
`
let ContainerSolicitar=styled.a`	
	position:absolute;
	right:-30px;
	top:-32px;
	font-size:20px;
	background-color:e8e8e8;
	border-radius:15px;
	padding:3px;
	color:#400040;
	display:flex;
	justify-content:center;
	align-items:center;
	filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.4));
	text-decoration:none
;
`


let ContainerMsgPromo=styled.div` 
	display:flex;
	align-items:center;
	position:absolute;	
	border-radius: 18px 18px 0px 0px;
	background-color: rgba(255, 255, 255,0.1);
	backdrop-filter: blur(3px);
	boxShadow:0 10px 20px 5px rgba(0,0,0,0.3);	
	overflow:hidden;
	width:96.3%;
	z-index:1;
	top:5px;
	left:6px
		
`;

let MsgPromo=styled.div` 
	font-family: 'Poppins', sans-serif;
	border-radius:25px;
	text-align:end;
	color:red;
	white-space: nowrap;
 	will-change: transform;
 	animation: ${marqueeTop} 20s linear infinite;
 	animation-timing-function: linear;
 	
 	`;


let VideoTutorial=styled.div`
	height:180px;
	width:300px;
	border-radius:23px 23px 0px 0px;
	background-size:cover;
	background-repeat:no-repeat;
	transition-duration:600ms;
	&:hover{
		opacity:0.2; 
	};`



let TituloTutorial=styled.div`

	display:flex;
	align-items:center;
	font-family: 'Poppins', sans-serif;
	justify-content:center;
	border-radius:0px 0px px 19px;
	color: #01578c;
	font-size:13px;
	background-color:white;
	width:100%;
	border-radius: 0px 0px 18px 18px;
	transition-duration:500ms;
	@media(max-width:450px){
		font-size:14px
	};
	
`
const TextoTitulo=styled.div`
text-align:center;
&:hover{
		background-image: linear-gradient(
        45deg,
        #CA4246 27.666%, 
        #E16541 27.666%, 
        #E16541 29.333%, 
        #F18F43 29.333%, 
        #F18F43 40%, 
        #8B9862 40%, 
        #8B9862 50.666%, 
        #476098 50.666%, 
        #476098 63.333%, 
        #A7489B 63.333%);
        -webkit-background-clip: text;
  		-webkit-text-fill-color: transparent;
  		background-size: 100%;
  	}
 `

let DescripcionTutorial=styled.div`
	position:absolute;
	background-color:white;
	height:150px;
	width:300px;
	border-radius:22px 22px 0px 0px;
	display:flex;
	justify-content:center;
	text-align: center;
	align-items:center;
	z-index:-1;
	font-size:17px;	
	
`

const DivCompartir=styled.div`
	color:red;
	display:flex;
	align-items:center;	
	display:flex;
	width:24px;
	transition:width 500ms;
	&:hover{
		width:130px;
	}
`
const MsjCompartir=styled.div`
	overflow:hidden;
	transition :width 100ms;
	height:20px;
`;


const CompartirCheck=styled.img`
	height:25px;
	padding:5px		
`



export default function CardProm(props){
	let tutorial=props.video;
	let idCopied=useSelector(state=>state.idCopied)
	const dispatch=useDispatch();  

			

	let chageIcon=(id)=>{
		let icons=document.getElementsByClassName("icon");
		for (let i=0;i<icons.length;i++){ icons[i].src=compartir };	
		document.getElementById(id+"ico").src=check;
	};

	let chageColor=(classname,id)=>{
		let texts=document.getElementsByClassName(classname);
		for (let i=0;i<texts.length;i++){ texts[i].style.color="red" };
		document.getElementById(id+"copiar").style.color="green"	
	}	


	let share=(nombre,id)=>{
		 	//const token=getToken();
			chageIcon(nombre);
			navigator.clipboard.writeText(`${baseURLCompartido}/Compartido/Reproductor/${id}`);
			chageColor("copiar",id);
			dispatch(setIdCopy(tutorial.ID))						
	};	

	

	let handleClick=(id,idVideo)=>{	

			
			dispatch(urlVideo(tutorial.video));
			dispatch(open(true));
			dispatch(setId(tutorial.ID))
	};


	return(
		<div>
			
			<Container>
				<ContainerMsgPromo><MsgPromo><b>adquiere esta herramineta avanzada</b></MsgPromo></ContainerMsgPromo>

				<div className="cardProm" id={tutorial.name}  >	

				<VideoTutorial onClick={()=>handleClick(tutorial.name,tutorial.ID)} style={{backgroundImage:tutorial.poster?`url(${tutorial.poster})`:`url(${logofarmasis})`}} />			
				

				<DescripcionTutorial id={tutorial.name+"Descrip"} className="Descrip" >
					<i style={{width:'90%'}}>{tutorial.descrip}</i>
				</DescripcionTutorial>
			
				<TituloTutorial id={tutorial.name+"Tit"}>
					<TextoTitulo><b>{tutorial.name}</b></TextoTitulo> 
					<DivCompartir title={idCopied===tutorial.ID?"Link copiado":"click para copiar el link"}  id={tutorial.ID+"copiar"} className="copiar" onClick={()=>share(tutorial.name,tutorial.ID)}  > 
						<CompartirCheck title={idCopied===tutorial.ID?"Link copiado":"click para copiar el link"} id={tutorial.name+"ico"} className="icon"  src={compartir}/> 
						<MsjCompartir >{idCopied===tutorial.ID?"Link copiado":"copiar Link"}</MsjCompartir>
					</DivCompartir>
				</TituloTutorial>		     		 
		
				</div>
			<ContainerSolicitar href ={`https://wa.me/51985862693?text=Hola, quisiera una cotisacion de la herramienta de "${tutorial.name.toUpperCase()}"`}  target="blank" ><b>cotizar</b><AddIcon style={{color:"green"}} /> </ContainerSolicitar>
			</Container>
		</div>
	)
}